export default "__VITE_ASSET__C6NtGt$t__"